var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.833 8a7.167 7.167 0 1 1 14.334 0A7.167 7.167 0 0 1 .833 8m8-.667a.5.5 0 0 0-.5-.5H7a.5.5 0 0 0 0 1h.833v3.5a.5.5 0 1 0 1 0zm0-2.667a.5.5 0 0 0-1 0v.667a.5.5 0 1 0 1 0z",
    clipRule: "evenodd"
  })));
};
export default SvgInfo;